import React from 'react';

import PropTypes from 'prop-types';

import {
    Lightbox,
    Modal,
} from 'wanderu-components';

import {
    NOT_STARTED,
    IN_PROGRESS,
    ERROR,
    CANCEL,
    SUCCESS_PRICE_UP,
    SUCCESS_UNAVAILABLE,
} from '../../constants';
import ErrorComponent, { ErrorTypes } from './ErrorComponent/ErrorComponent';
import LiveCheckLoader from './LiveCheckLoader/LiveCheckLoader';
import PriceUp from './PriceUpComponent/PriceUpComponent';
import events from './events/LiveCheckEvents';

import styles from './LiveCheckModal.scss';

class LiveCheckModal extends React.Component {
    static propTypes = {
        carrierCode: PropTypes.string,
        carrierName: PropTypes.string,
        departDateTimeUTC: PropTypes.number,
        funnelStage: PropTypes.string,
        isRouted: PropTypes.bool,
        liveCheckData: PropTypes.object,
        modalState: PropTypes.string,
        newPrice: PropTypes.arrayOf(PropTypes.object),
        onContinue: PropTypes.func,
        onGoBack: PropTypes.func,
        originalPrice: PropTypes.arrayOf(PropTypes.object),
        seats: PropTypes.number,
        tripId: PropTypes.string,
        trips: PropTypes.arrayOf(PropTypes.object),
    };

    static defaultProps = {
        carrierName: '',
        isRouted: false,
        modalState: NOT_STARTED,
        newPrice: [{}],
        onContinue: () => undefined,
        onGoBack: () => undefined,
        originalPrice: [{}],
        tripId: '',
    };

    onGoBack = (type) => {
        const goBack = () => {
            const {
                onGoBack,
                tripId,
            } = this.props;
            events.goBackClicked({ tripId, type });
            onGoBack();
        };
        return goBack;
    };

    onContinue = () => {
        const {
            onContinue,
            tripId,
        } = this.props;
        events.continueClicked({ tripId });
        onContinue();
    };

    renderModalContents() {
        const {
            carrierCode,
            carrierName,
            departDateTimeUTC,
            funnelStage,
            isRouted,
            liveCheckData,
            modalState,
            newPrice,
            originalPrice,
            seats,
            tripId,
            trips,
        } = this.props;

        if (modalState === IN_PROGRESS) {
            const onLoad = () => events.liveCheckInProgressViewed({
                carrierCode,
                departDateTimeUTC,
                funnelStage,
                originalPrice,
                tripId,
                uiViewed: 'modal',
            });
            return <LiveCheckLoader
                carrierCode={carrierCode}
                carrierName={carrierName}
                onLoad={onLoad}
            />;
        }

        const onLoad = () => events.liveCheckResultViewed({
            funnelStage,
            liveCheckData,
            modalState,
            seats,
            trips,
            uiViewed: 'modal',
        });

        if (modalState === SUCCESS_PRICE_UP) {
            return (
                <PriceUp
                    carrierCode={carrierCode}
                    carrierName={carrierName}
                    isRouted={isRouted}
                    newPrice={newPrice}
                    onContinue={this.onContinue}
                    onGoBack={this.onGoBack(SUCCESS_PRICE_UP)}
                    onLoad={onLoad}
                    originalPrice={originalPrice}
                />
            );
        }

        if (modalState === SUCCESS_UNAVAILABLE) {
            return (
                <ErrorComponent
                    errorType={ErrorTypes.SUCCESS_UNAVAILABLE}
                    onGoBack={this.onGoBack(SUCCESS_UNAVAILABLE)}
                    onLoad={onLoad}
                />
            );
        }

        return (
            <ErrorComponent onGoBack={this.onGoBack(ERROR)} onLoad={onLoad} />
        );
    }

    render() {
        const {
            modalState,
        } = this.props;
        if (modalState === NOT_STARTED) {
            return null;
        }

        return (
            <Modal>
                <Lightbox
                    className={styles.container}
                    closeModalOnOutsideClick={false}
                    id={`livecheck-modal-${modalState}`}
                    innerClassName={styles.containerInner}
                    onHide={this.onGoBack(CANCEL)}
                    showCloseButton
                >
                    {this.renderModalContents()}
                </Lightbox>
            </Modal>
        );
    }
}

export default LiveCheckModal;
